<template>
  <div class="isTxt" v-if="isTxt">
    {{ name || '-' }}
  </div>
  <el-date-picker
    v-else
    style="width: 100%"
    v-model="innerValue"
    :type="renderConfig.type"
    :format="renderConfig.format"
    :value-format="renderConfig.format"
    :placeholder="renderConfig.placeholder"
    :start-placeholder="renderConfig.placeholder"
    :disabled="renderConfig.disabled"
    :defaultTime="defaultTime"
    :shortcuts="shortcuts"
    :end-placeholder="renderConfig.placeholder"
  />
</template>

<script lang="ts" setup>
import { computed, ref, onMounted, watch } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { isNullOrUndefOrEmpty } from '@/utils/is'
import { getAssociatedData } from '@/components/custom/form/components/utils'
import { useDealAssociatedData } from '@/hooks/useDealAssociatedData'
import dayjs from 'dayjs'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue'])
const defaultTime: [Date, Date] = [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 2, 1, 23, 59, 59)]
const innerValue = computed({
  get() {
    return props.modelValue || []
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})
const name = ref('')
onMounted(() => {
  name.value = innerValue.value?.join?.(',') || '-'
})

const shortcuts = [
  {
    text: '昨天',
    value: () => {
      const yesterday = dayjs().subtract(1, 'day')
      return [yesterday.startOf('day').toDate(), yesterday.endOf('day').toDate()]
    }
  },
  {
    text: '今天',
    value: () => {
      const today = dayjs()
      return [
        today.startOf('day').toDate(),
        today.toDate() // 当前时间，若需要回顾类操作可改为 today.endOf('day').toDate()
      ]
    }
  },
  {
    text: '近1天',
    value: () => {
      const now = dayjs()
      return [now.subtract(1, 'day').toDate(), now.toDate()]
    }
  },
  {
    text: '近3天',
    value: () => {
      const now = dayjs()
      return [now.subtract(3, 'day').toDate(), now.toDate()]
    }
  },
  {
    text: '近1周',
    value: () => {
      const now = dayjs()
      return [now.subtract(7, 'day').toDate(), now.toDate()]
    }
  },
  {
    text: '近2周',
    value: () => {
      const now = dayjs()
      return [now.subtract(14, 'day').toDate(), now.toDate()]
    }
  },
  {
    text: '近1月',
    value: () => {
      const now = dayjs()
      return [now.subtract(1, 'month').toDate(), now.toDate()]
    }
  }
]
// 回显值获取函数(关联已有数据)
const getFetchAssociatedData = () => {
  return getAssociatedData(props).then((res: Recordable) => {
    innerValue.value = res.value ? res.value.split(',') : []
    return res
  })
}

watch(
  // 避免新值和旧值一样的情况(监听"引用类型")
  () => JSON.parse(JSON.stringify(props.formData)),
  (newFormData, oldFormData) => {
    if (isNullOrUndefOrEmpty(innerValue.value)) {
      useDealAssociatedData(props, oldFormData, getFetchAssociatedData)
    }
  },
  { immediate: true, deep: true }
)
</script>
